import type { ComponentProps } from 'react';

const CheckMyCoverage = (props: ComponentProps<'svg'>) => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M32.6766 36.5952H6V38.0162H32.6766V36.5952Z" fill="#E3E0DB" />
      <path
        d="M15.955 19.8061H14.5078V16.328C14.5161 15.8833 14.7085 15.4598 15.0428 15.1506C15.3771 14.8415 15.826 14.6719 16.2909 14.6791H22.2274C22.6926 14.6719 23.1418 14.8414 23.4767 15.1504C23.8115 15.4595 24.0046 15.883 24.0137 16.328V19.6319H22.5665V16.328C22.557 16.2504 22.5162 16.1794 22.4529 16.1301C22.3897 16.0808 22.3087 16.0569 22.2274 16.0637H16.2909C16.2101 16.0578 16.13 16.0819 16.0674 16.1312C16.0048 16.1805 15.9645 16.251 15.955 16.328V19.8061Z"
        fill="#782E2B"
      />
      <path
        d="M28.1695 19.5479H10.7243C9.2003 19.5479 7.96484 20.7299 7.96484 22.188V33.8926C7.96484 35.3507 9.2003 36.5327 10.7243 36.5327H28.1695C29.6935 36.5327 30.929 35.3507 30.929 33.8926V22.188C30.929 20.7299 29.6935 19.5479 28.1695 19.5479Z"
        fill="#FFC5A8"
      />
      <path
        d="M30.929 24.5127V22.191C30.929 21.4905 30.6384 20.8187 30.1209 20.3231C29.6035 19.8275 28.9017 19.5487 28.1695 19.5479H10.7243C9.99216 19.5487 9.29029 19.8275 8.77288 20.3231C8.25547 20.8187 7.96484 21.4905 7.96484 22.191V24.5127H30.929Z"
        fill="#F88E7A"
      />
      <path
        d="M23.9371 29.1921H15.1973V30.6939H23.9371V29.1921Z"
        fill="#E06358"
      />
      <path
        d="M33.2765 9.42859H31.5781V12.8976H33.2765V9.42859Z"
        fill="#E3E0DB"
      />
      <path
        d="M38.7786 10.6764L35.873 13.6857L37.1206 14.7883L40.0262 11.779L38.7786 10.6764Z"
        fill="#E3E0DB"
      />
      <path
        d="M42.5167 16.7858L38.5098 16.9076L38.5637 18.5317L42.5706 18.4098L42.5167 16.7858Z"
        fill="#E3E0DB"
      />
      <path
        d="M20.4857 25.9995H18.916V33.8596H20.4857V25.9995Z"
        fill="#E06358"
      />
      <path
        d="M37.2617 19.1723C35.9013 23.3882 34.496 26.3448 31.0174 27.2579C30.8827 27.2299 30.7535 27.1999 30.6244 27.1644C26.401 25.9948 24.8086 19.6682 24.8086 19.6682C28.2348 18.0177 30.4092 14.3519 30.6244 13.9777L30.6413 13.9478C30.6413 13.9478 33.9908 18.0533 37.2617 19.1723Z"
        fill="#4F9493"
      />
      <path
        d="M37.2623 19.1725C35.9019 23.3884 34.4966 26.3449 31.018 27.2581C30.887 19.4138 30.625 13.9723 30.625 13.9723L30.6418 13.9423C30.6418 13.9423 33.9914 18.0534 37.2623 19.1725Z"
        fill="#355D60"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M31.1152 21.1678L30.3302 21.8343L28.9841 20.2985L28.1972 20.9658L30.2266 23.2803L30.5742 22.9852C30.5847 22.9717 30.595 22.958 30.6052 22.9443L34.0847 19.9987L33.4038 19.214L31.118 21.1464L31.1152 21.1678Z"
        fill="#DDF2F1"
      />
    </svg>
  );
};

export default CheckMyCoverage;
